module.exports = __webpack_public_path__ + "static/media/pcb2.15b420f3.jpg";